import { render, staticRenderFns } from "./expertReviewSettings.vue?vue&type=template&id=0966c0d1&scoped=true&"
import script from "./expertReviewSettings.vue?vue&type=script&lang=js&"
export * from "./expertReviewSettings.vue?vue&type=script&lang=js&"
import style0 from "./expertReviewSettings.vue?vue&type=style&index=0&id=0966c0d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0966c0d1",
  null
  
)

export default component.exports